import React from "react";
import { Link as RouterLink, matchPath, useLocation } from "react-router-dom";
import { Link, Typography, Breadcrumbs as MuiBreadcrumbs, } from "@material-ui/core";
import { NavigateNext } from "@material-ui/icons";
import { paths } from "frontend/src/pages/paths/index";
var url = paths.business.owner;
var routes = [
    { name: "Главная", url: url.home() },
    { name: "Мои плейлисты", url: url.playlists.index("private") },
    { name: "Плейлисты imstream", url: url.playlists.index("public") },
    { name: "Редактирование", url: url.playlists.edit(":id") },
    { name: "Просмотр", url: url.playlists.view(":id") },
    { name: "Расписание плейлистов", url: url.schedules.index() },
    { name: "Редактирование", url: url.schedules.edit(":id") },
    { name: "Сетки вещания", url: url.timetables.index() },
    { name: "Редактирование", url: url.timetables.edit(":id") },
    { name: "Загруженные файлы", url: url.files.index() },
    { name: "Мои данные", url: url.details.index() },
];
var mapPathName = function (pathname) {
    return routes.filter(function (_a) {
        var url = _a.url;
        return matchPath(pathname, { path: url, exact: false, strict: false });
    });
};
export var Breadcrumbs = function () {
    var pathname = useLocation().pathname;
    var paths = mapPathName(pathname);
    return (React.createElement(MuiBreadcrumbs, { separator: React.createElement(NavigateNext, { fontSize: "small" }) }, paths.map(function (_a, index, array) {
        var name = _a.name, url = _a.url;
        return index < array.length - 1 ? (React.createElement(Link, { component: RouterLink, color: "inherit", to: url, key: index }, name)) : (React.createElement(Typography, { color: "textPrimary", key: index }, name));
    })));
};
